<template>
  <div id="open-day">
    <h1 id="title">OPEN DAY</h1>
    <hr />
    <p id="description">{{ OpenDayInfo.Description}}</p>
    <div id="schedule">
      <div id="left-side">
        <div
          class="speech-element margin-left"
          v-for="(speech, index) in leftSideSpeeches"
          :key="index"
        >
          <div class="flag-shadow">
            <div class="flag-rotated">
              <h2 class="speech-title unselectable right-align">{{speech.Title}}</h2>
            </div>
          </div>
          <h1 class="speech-period right-align">{{speech.Period}}</h1>
          <div class="speech-description-container">
            <p class="speech-description right-align">{{speech.Description}}</p>
          </div>
        </div>
      </div>
      <div id="flag-pole"></div>
      <div id="right-side">
        <div class="speech-element" v-for="(speech, index) in rightSideSpeeches" :key="index">
          <div class="flag-shadow-rotated">
            <div class="flag">
              <h2 class="speech-title unselectable left-align">{{speech.Title}}</h2>
            </div>
          </div>
          <h1 class="speech-period left-align">{{speech.Period}}</h1>
          <p class="speech-description left-align">{{speech.Description}}</p>
        </div>
      </div>
      <div id="mobile-schedule">
        <div class="speech-element" v-for="(speech, index) in OpenDayInfo.Speeches" :key="index">
          <div class="flag-shadow-rotated">
            <div class="flag">
              <h2 class="speech-title unselectable">{{speech.Title}}</h2>
            </div>
          </div>
          <h1 class="speech-period left-align">{{speech.Period}}</h1>
          <p class="speech-description left-align">{{$t(speech.Description)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OpenDayInfo from "@/assets/resources/openDay.js";

export default {
  data() {
    return {
      OpenDayInfo
      // OpenDayInfo: {Description: "Bla Bla", Speeches: [{Title: "Urmeaza sa fie anuntat", Period:"12:00 -12: 00", Description:"loremIpsum"},]}
    };
  },
  computed: {
    rightSideSpeeches: function () {
      return this.OpenDayInfo.Speeches.filter((speech, index) => {
        if (index % 2 == 0) return true;
      });
    },
    leftSideSpeeches: function () {
      return this.OpenDayInfo.Speeches.filter((speech, index) => {
        if (index % 2 != 0) return true;
      });
    },
  },
};
</script>


<style lang="scss" scoped>
#title,
#description {
  color: #edf6fb;
  font-family: "Acumin Variable Concept";
  text-align: center;
}

#open-day {
  background-color: #0d2a4c;
}

hr {
  border-color: #f37298; //asta e pentru Chrome
  background-color: #f37298; //asta e pentru Firefox
  border-radius: 1vw;
  height: 0.7vh;
  width: 20vw;
  margin: auto;
  margin-bottom: 8vh;
}

#description {
  width: 80vw;
  margin: auto;
  font-size: 1.5vw;
  margin-bottom: 10vh;
}

#schedule {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

#mobile-schedule {
  display: none;
}

#left-side,
#right-side {
  width: 49vw;
  position: relative;
  z-index: 1;
}

.border-left {
    border-left: 0.5vw solid #EDF6FB;
}

.border-right {
    border-right: 0.5vw solid #EDF6FB;
}

.margin-left {
  margin-left: 20%;
}

.speech-element {
  width: 80%;
}

.move-right {
  position: relative;
  right: 0;
}

#flag-pole {
  position: relative;
  top: -0.1vh;
  width: 0.5vw;
  height: 125vw; //asta trebuie modificata daca mai sunt adaugate sau sterse speech-uri, sau daca este schimbata lungimea lor
  background-color: #edf6fb;
}

.flag,
.flag-rotated {
  position: relative;
  height: 4.5vw;
  background-color: #f37298;
}

.flag {
  left: -0.3vw;
  clip-path: polygon(90% 0, 85% 50%, 90% 100%, 0 100%, 0 0);
}

.flag-rotated {
  left: 0.3vw;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 10% 100%, 15% 50%);
}

.flag-shadow {
  filter: drop-shadow(3px 0px 7px rgba(0, 0, 0, 0.75));
}

.flag-shadow-rotated {
  filter: drop-shadow(-3px 0px 7px rgba(0, 0, 0, 0.75));
}

.speech-title,
.speech-period,
.speech-description {
  color: #edf6fb;
  font-family: "Acumin Variable Concept";
}

.speech-title {
  font-size: 5vw;
  font-weight: bold;
  position: relative;
  top: 17%;// nu am putut sa-l centrez vertical altfel :/
  font-size: 2vw;
}

.speech-period {
  margin-top: 1vw;
  margin-bottom: 2vw;
  font-size: 2.3vw;
}

.speech-description {
  margin-bottom: 3vw;
  font-size: 1.5vw;
}

.left-align {
  text-align: left;
  margin-left: 1vw;
}

.right-align {
  text-align: right;
  margin-right: 1vw;
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#left-side:first-child {
  margin-top: 25vh;
}

@media screen and (max-width: 1024px) {
  #left-side,
  #right-side,
  #flag-pole {
    display: none;
  }

  #mobile-schedule {
    display: block;
    margin-left: 7vw;
    border-left: 0.6vw solid #edf6fb;
  }

  hr {
    width: 45vw;
    height: 1vh;
    margin-bottom: 5vh;
  }

  #description {
    font-size: 2.5vw;
  }

  .flag {
    height: 6vw;
  }

  .speech-description,
  .speech-title,
  .speech-period {
    margin-left: 2vw;
  }

  .speech-element {
    width: 95%;
  }

  .speech-title {
    text-align: left;
    top: 10%;
    font-size: 3.4vw;
  }

  .speech-period {
    margin-top: 3vh;
    font-size: 2.9vw;
  }

  .speech-description {
    font-size: 2.2vw;
    margin-bottom: 5vh;
    width: 85%;
  }

  .flag-shadow-rotated {
    filter: drop-shadow(-3px 0px 5px rgba(0, 0, 0, 0.75));
  }
}
</style>